"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Essay_exports = {};
__export(Essay_exports, {
  default: () => Essay_default
});
module.exports = __toCommonJS(Essay_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M17.1602 4.58594C17.3424 4.58594 17.4987 4.65104 17.6289 4.78125C17.7591 4.91146 17.8242 5.06771 17.8242 5.25V15.25C17.8242 15.4323 17.7591 15.5885 17.6289 15.7188C17.4987 15.849 17.3424 15.9141 17.1602 15.9141H3.83984C3.65755 15.9141 3.5013 15.849 3.37109 15.7188C3.24089 15.5885 3.17578 15.4323 3.17578 15.25V5.25C3.17578 5.06771 3.24089 4.91146 3.37109 4.78125C3.5013 4.65104 3.65755 4.58594 3.83984 4.58594H17.1602ZM3.83984 3.58984C3.37109 3.58984 2.97396 3.7526 2.64844 4.07812C2.32292 4.40365 2.16016 4.79427 2.16016 5.25V15.25C2.16016 15.7057 2.32292 16.0964 2.64844 16.4219C2.97396 16.7474 3.37109 16.9102 3.83984 16.9102H17.1602C17.6289 16.9102 18.026 16.7474 18.3516 16.4219C18.6771 16.0964 18.8398 15.7057 18.8398 15.25V5.25C18.8398 4.79427 18.6771 4.40365 18.3516 4.07812C18.026 3.7526 17.6289 3.58984 17.1602 3.58984H3.83984ZM5.5 8.16016C5.5 8.04297 5.53906 7.94531 5.61719 7.86719C5.69531 7.78906 5.79297 7.75 5.91016 7.75H9.25C9.36719 7.75 9.46484 7.78906 9.54297 7.86719C9.62109 7.94531 9.66016 8.04297 9.66016 8.16016C9.66016 8.27734 9.62109 8.38151 9.54297 8.47266C9.46484 8.55078 9.36719 8.58984 9.25 8.58984H5.91016C5.79297 8.58984 5.69531 8.55078 5.61719 8.47266C5.53906 8.38151 5.5 8.27734 5.5 8.16016ZM5.5 10.6602C5.5 10.543 5.53906 10.4453 5.61719 10.3672C5.69531 10.2891 5.79297 10.25 5.91016 10.25H15.0898C15.207 10.25 15.3047 10.2891 15.3828 10.3672C15.4609 10.4453 15.5 10.543 15.5 10.6602C15.5 10.7773 15.4609 10.8815 15.3828 10.9727C15.3047 11.0508 15.207 11.0898 15.0898 11.0898H5.91016C5.79297 11.0898 5.69531 11.0508 5.61719 10.9727C5.53906 10.8815 5.5 10.7773 5.5 10.6602ZM5.5 13.1602C5.5 13.043 5.53906 12.9453 5.61719 12.8672C5.69531 12.7891 5.79297 12.75 5.91016 12.75H15.0898C15.207 12.75 15.3047 12.7891 15.3828 12.8672C15.4609 12.9453 15.5 13.043 15.5 13.1602C15.5 13.2773 15.4609 13.3815 15.3828 13.4727C15.3047 13.5508 15.207 13.5898 15.0898 13.5898H5.91016C5.79297 13.5898 5.69531 13.5508 5.61719 13.4727C5.53906 13.3815 5.5 13.2773 5.5 13.1602Z",
      fill: "currentColor"
    }
  )
);
const SvgEssay = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Essay_default = SvgEssay;
